import { v4 as uuid } from "uuid";

// NOTE: don't use this symbol by hand.
// use one of those function to get and set a guid
// for an object.
const GUID = Symbol("GUID");

export const defineGuid = obj => ({
  [GUID]: uuid(),
  ...obj
});

export const objectGuid = obj => obj[GUID];
